




































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DaisyMessage from '@/domain/daisy-message/entity/daisy-message.entity';
import HtmlSanitizer from '@/shared/utils/html-sanitizer';

const SAMPLE_NAME = 'João';

@Component({
  components: {
    ModalComponent,
    LabelSlot,
  },
})
export default class DaisyMessagePreviewModalComponent extends Vue {
  @Prop({
    type: Boolean,
  }) openModal!: boolean;

  @Prop() message!: DaisyMessage;

  sampleName = SAMPLE_NAME;

  get options(): ModalOptions {
    return {
      title: 'Pré-visualizar Mensagem',
      titleSize: '20px',
      showOk: false,
      showCancel: true,
      labelCancel: 'Fechar',
      width: 600,
    };
  }

  get previewContent(): string {
    if (!this.message || !this.message.content) return '';
    return this.message.content.replace(/{name}/g, this.sampleName);
  }

  get sanitizedContent(): string {
    return HtmlSanitizer.sanitize(this.previewContent);
  }

  closeModal(): void {
    this.$emit('closeModal');
  }
}
